<template>
  <div class="m-l-50 m-t-30 w-500" v-loading="loading">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="使用消息通道">
        <el-checkbox-group v-model="form.FLOW_PIPELINES">
          <el-checkbox
            v-for="option in pipelines"
            :label="option.id">
            {{ option.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="可用模板变量标签">
        <el-table
          :data="templet"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="变量名"
            style="width:50%">
          </el-table-column>
          <el-table-column
            prop="tag"
            label="标签"
            style="width:50%">
          </el-table-column>
        </el-table>
      </el-form-item>
      <!-- <el-form-item :label="titles[key]" v-for="(item, key) in form.messages">
        <div class="m-b-10">
          <span>标题</span>
          <el-input v-model="item.title"></el-input>
        </div>
        <div class="m-b-10">
          <span>内容</span>
          <el-input type="textarea" :rows="4" v-model="item.content"></el-input>
        </div>
      </el-form-item> -->
      <el-form-item label="审批/任务收到待办时提醒内容">
        <div class="m-b-10">
          <span>标题</span>
          <el-input v-model="form.FLOW_MSG_RECEIVE_TITLE"></el-input>
        </div>
        <div class="m-b-10">
          <span>内容</span>
          <el-input type="textarea" :rows="4" v-model="form.FLOW_MSG_RECEIVE_CONTENT"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="审批退回通知时提醒内容">
        <div class="m-b-10">
          <span>标题</span>
          <el-input v-model="form.FLOW_MSG_BACK_TITLE"></el-input>
        </div>
        <div class="m-b-10">
          <span>内容</span>
          <el-input type="textarea" :rows="4" v-model="form.FLOW_MSG_BACK_CONTENT"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="流程结束提醒申请人时提醒内容">
        <div class="m-b-10">
          <span>标题</span>
          <el-input v-model="form.FLOW_MSG_END_TITLE"></el-input>
        </div>
        <div class="m-b-10">
          <span>内容</span>
          <el-input type="textarea" :rows="4" v-model="form.FLOW_MSG_END_CONTENT"></el-input>
        </div>
      </el-form-item>
      <el-form-item>
        <el-form-item label="自动知会消息提醒内容">
          <div class="m-b-10">
            <span>标题</span>
            <el-input v-model="form.FLOW_NOTIFY_TITLE"></el-input>
          </div>
          <div class="m-b-10">
            <span>内容</span>
            <el-input type="textarea" :rows="4" v-model="form.FLOW_NOTIFY_CONTENT"></el-input>
          </div>
        </el-form-item>
        <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from 'assets/js/http'

  export default {
    data() {
      return {
        loading: false,
        isLoading: false,
        pipelines: [],
        templet: [
          { name: '流程主题（实例化表单名称）', tag: '${formname}' },
          { name: '流程名称', tag: '${flowname}' },
          { name: '节点名称', tag: '${nodename}' },
          { name: '发起人名称（仅知会消息可用）', tag: '${foundername}' },
          { name: '处理人名称（仅知会消息可用）', tag: '${transactorname}' },
          { name: '处理动作', tag: '${dealtype}' }
        ],
        form: {
          FLOW_PIPELINES: [],
          FLOW_MSG_RECEIVE_TITLE: '',
          FLOW_MSG_RECEIVE_CONTENT: '',
          FLOW_MSG_BACK_TITLE: '',
          FLOW_MSG_BACK_CONTENT: '',
          FLOW_MSG_END_TITLE: '',
          FLOW_MSG_END_CONTENT: '',
          FLOW_NOTIFY_TITLE: '',
          FLOW_NOTIFY_CONTENT: ''
          // messages: {
          //   receive: { title: '', content: '' },
          //   back: { title: '', content: '' },
          //   end: { title: '', content: '' }
          // }
        },
        rules: {
        }
        // titles: {
        //   receive: '审批/任务收到待办时提醒内容',
        //   back: '审批退回通知时提醒内容',
        //   end: '流程结束提醒申请人时提醒内容'
        // }
      }
    },
    methods: {
      async getDetail() {
        this.loading = true
        let res = await this.apiGet('bpm/flows/getConfig')
        let data = this.promiseHandler(data, res)
        if (data) {
          _(this.form).forEach((res, key) => {
            if (data[key]) {
              this.form[key] = data[key]
            }
          })
        }
        this.loading = false
      },
      async getPipilines() {
        let res = await this.apiGet('msg/pipeline')
        let data = this.promiseHandler(data, res)
        if (data) {
          this.pipelines = data.list
        }
      },
      async add() {
        this.isLoading = true
        let res = await this.apiPost('bpm/flows/saveConfig', this.form)
        if (res.code == 200) {
          _g.toastMsg(this, 'success', '保存成功！')
          setTimeout(() => {
            this.goback()
          }, 1000)
        } else {
          _g.dealError(this, res)
        }
        this.isLoading = false
      },
      goback() {
        router.go(-1)
      }
    },
    created() {
      this.getDetail()
      this.getPipilines()
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// message.vue?bc328814